module.exports = __webpack_public_path__ + "static/media/chair-office.b8ccfc8f.svg";